import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { FollowUpSuggestions } from './FollowUpSuggestions';
export const GetDismissedMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const DismissedMessage = (param)=>{
    let { content, messageId, showFollowUpSuggestions = true, onSuggestionClick, onSubmitFeedback, onDismissFeedback } = param;
    const { DismissedMessageTID } = useMemo(()=>GetDismissedMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": DismissedMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: DismissedMessageTID.Intro(),
                children: content.intro
            }),
            content.followUp != null && /*#__PURE__*/ _jsx(FollowUpSuggestions, {
                followUp: content.followUp,
                showSuggestions: showFollowUpSuggestions,
                biName: "dismissed_followup_suggestion",
                onSuggestionClick: onSuggestionClick,
                testIds: {
                    FollowUp: DismissedMessageTID.FollowUp,
                    FollowUpText: DismissedMessageTID.FollowUpText,
                    FollowUpSuggestions: DismissedMessageTID.FollowUpSuggestions,
                    FollowUpSuggestion: DismissedMessageTID.FollowUpSuggestion
                }
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
